module.exports = __webpack_public_path__ + "static/media/rackham01full.fd4044f7.jpg";